import { render } from "./EthiotelEnglishTerms.vue?vue&type=template&id=40767d3e&scoped=true"
import script from "./EthiotelEnglishTerms.vue?vue&type=script&lang=js"
export * from "./EthiotelEnglishTerms.vue?vue&type=script&lang=js"

import "./EthiotelEnglishTerms.vue?vue&type=style&index=0&id=40767d3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40767d3e"]])

export default __exports__